import r from "./_cb.js";
import o from "./each.js";
function t(t, n) {
  return function (u, f, a) {
    var c = n ? [[], []] : {};
    return f = r(f, a), o(u, function (r, o) {
      var n = f(r, o, u);
      t(c, r, n);
    }), c;
  };
}
export { t as default };